import { supabase } from './SupabaseClient';

export interface RestrictedAccessPublicSettings {
  enabled: boolean;
}

export interface RestrictedAccessLinkRequestResponse {
  success: boolean;
  message: string;
}

class RestrictedAccessService {
  public async getPublicSettings(): Promise<RestrictedAccessPublicSettings> {
    const { data, error } = await supabase.rpc('get_restricted_access_email_link_enabled');

    if (error) {
      throw new Error(error.message);
    }

    const enabled = data === true;
    return { enabled };
  }

  public async requestLoginLink(
    email: string,
    options: { website?: string; startedAt?: number | null } = {}
  ): Promise<RestrictedAccessLinkRequestResponse> {
    const response = await fetch('/.netlify/functions/restricted-access-link', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email.trim(),
        website: options.website || '',
        startedAt: options.startedAt ?? null,
      }),
    });

    const body = await response.json().catch(() => ({})) as Partial<RestrictedAccessLinkRequestResponse>;

    if (!response.ok) {
      throw new Error(body.message || `Echec de la demande (${response.status})`);
    }

    return {
      success: body.success === true,
      message: body.message || 'Si cette adresse e-mail existe, un lien de connexion sera envoye.',
    };
  }
}

export const restrictedAccessService = new RestrictedAccessService();
